<template>
  <OnBoarding>
    <template>
      <CRow>
        <CCol>
          <OnBoardingHeader :title="$pgettext('login.title', 'Login')"/>

          <!-- LDAP Login -->
          <LdapLoginForm
            v-if="currentMode === AuthProviders.LDAP"
            @login-success="afterLogin"
            @switch-provider="switchMode"
          />

          <!-- Password Login -->
          <PasswordLoginForm
            v-else-if="currentMode === AuthProviders.PASSWORD"
            :allow-register="allowRegister"
            :initial-email="initialEmail"
            @login-success="afterLogin"
            @switch-provider="switchMode"
          />

          <!-- Email Token Login -->
          <EmailTokenLoginForm
            v-else-if="currentMode === AuthProviders.EMAIL_TOKEN"
            :initial-email="pendingTokenLogin || initialEmail"
            @login-success="afterLogin"
            @switch-provider="switchMode"
          />

          <!-- Social Login Buttons (if any social provider is enabled) -->
          <template v-if="isSocialEnabled">
            <div class="text-center info">
              <span v-translate>otherwise</span>
            </div>
            <SocialLoginButtons
              :allow-register="allowRegister"
              @login-success="afterLogin"
            />
          </template>

          <!-- Registration Link -->
          <div class="text-center pt-3" v-if="allowRegister">
            <h5 class="font-weight-medium" style="font-size: 16px">
              <translate>Don't have an account?</translate>
              <CLink :to="{name: 'register'}" class="ml-2 font-weight-semi-bold">
                <span v-translate>Sing up</span>
                <CIcon class="ml-2" size="custom-size" :height="20" name="cip-log-out-04"/>
              </CLink>
            </h5>
          </div>
        </CCol>
      </CRow>
    </template>
  </OnBoarding>
</template>

<script>
import {mapGetters} from "vuex";
import SocialLoginButtons from "@/domain/login/components/providers/SocialLoginButtons.vue";
import LdapLoginForm from "@/domain/login/components/providers/LdapLoginForm.vue";
import PasswordLoginForm from "@/domain/login/components/providers/PasswordLoginForm.vue";
import EmailTokenLoginForm from "@/domain/login/components/providers/EmailTokenLoginForm.vue";
import {methods} from "@/domain/login/mixin";
import OnBoarding from "@/domain/login/OnBoarding.vue";
import OnBoardingHeader from "@/domain/login/components/OnBoardingHeader.vue";
import {AuthProviders} from "@/domain/login/constant/authProviders";

export default {
  name: 'Login',
  components: {
    OnBoardingHeader,
    OnBoarding,
    SocialLoginButtons,
    LdapLoginForm,
    PasswordLoginForm,
    EmailTokenLoginForm
  },
  props: {
    allowRegister: {
      type: Boolean,
      default: true
    }
  },
  async mounted() {
    await this.checkQueryParams()

    // Determine mode from URL query param or use primary provider
    const modeFromQuery = this.$route.query.mode
    const initialEmail = this.$route.query.email

    if (modeFromQuery && this.authProviderFactory.isEnabled(modeFromQuery)) {
      this.currentMode = modeFromQuery
    } else if (this.pendingTokenLogin || this.registrationFlow) {
      // If there's a pending token login, use email_token mode
      this.currentMode = AuthProviders.EMAIL_TOKEN
    } else {
      // Use primary provider based on what's enabled (priority order)
      this.currentMode = this.authProviderFactory.getPrimary()
    }

    if (initialEmail) {
      this.initialEmail = initialEmail
    }
  },
  data() {
    return {
      currentMode: null,
      initialEmail: null,
      AuthProviders // Make constants available in template
    }
  },
  computed: {
    ...mapGetters('login', ['pendingTokenLogin', 'registrationFlow', 'userLanguage', 'authProviderFactory']),
    isSocialEnabled() {
      return this.authProviderFactory.hasSocial()
    }
  },
  methods: {
    ...methods,

    switchMode(mode) {
      this.currentMode = mode

      // Update URL query param without navigation
      this.$router.replace({
        query: {...this.$route.query, mode}
      })
    }
  }
}
</script>
